import { inject, defineComponent, useCssModule } from '@nuxtjs/composition-api';
export default defineComponent({
    name: 'BoxCustomBlock',
    props: {
        box: {
            required: true,
            type: Object,
        },
        schemaDisabled: {
            default: false,
            type: Boolean,
        },
    },
    setup() {
        const css = useCssModule();
        const article = inject('article');
        return {
            article,
            css,
        };
    },
});
